import { ICollaboratorSchema } from "@wingspanhq/payments/dist/interfaces";

interface CollaboratorsFindBy {
  email?: string;
  collaboratorId?: string;
  contractorId?: string;
}

export const getMatchingCollaborators = (
  collaborators: ICollaboratorSchema[],
  findBy: CollaboratorsFindBy
) => {
  const { email, collaboratorId, contractorId } = findBy;
  if (email) {
    return collaborators.filter(
      collaborator =>
        collaborator.member.user.email?.toLowerCase() === email.toLowerCase()
    );
  }
  if (collaboratorId) {
    return collaborators.filter(
      collaborator => collaborator.collaboratorId === collaboratorId
    );
  }
  if (contractorId) {
    return collaborators.filter(collaborator => {
      if (collaborator.clientData?.externalId) {
        return collaborator.clientData.externalId === contractorId;
      }
      return collaborator.labels?.contractorId === contractorId;
    });
  }
  return [];
};
